/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SchoolEducationDetailViewModel } from "../types/SchoolEducationDetailViewModel.ts";
import { eSchoolEducationLevelSchema } from "./eSchoolEducationLevelSchema.ts";

export const schoolEducationDetailViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID do registro de formação escolar."),
  ),
  studentId: z.optional(
    z.number().int().describe("ID do aluno ao qual a formação pertence."),
  ),
  school: z.string().describe("Nome da instituição de ensino.").nullish(),
  course: z.string().describe("Nome do curso realizado.").nullish(),
  area: z.string().describe("Área de conhecimento do curso.").nullish(),
  level: z.optional(
    z
      .lazy(() => eSchoolEducationLevelSchema)
      .describe(
        "0 = Uninformed | 1 = FullTop | 2 = Master | 3 = Doctor | 4 = Expert | ",
      ),
  ),
  levelName: z
    .string()
    .describe("Nome legível do nível de escolaridade.")
    .nullish(),
  dateCompletion: z
    .string()
    .datetime()
    .describe("Data de conclusão do curso. Opcional.")
    .nullish(),
}) as unknown as ToZod<SchoolEducationDetailViewModel>;
